import {FC, useEffect} from 'react'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {Column} from 'react-table'
import {BedBookingModel} from '../../../../models/booking.model'
import {getBedsFromBookingService} from '../../../../services/booking.service'

const TableGuestBooking: FC = () => {
  const {data, setData, setPagination, loading, setLoading, pagination} = useKTable()
  const {currentTabItem} = useHoteleria()

  const getBedBookings = async () => {
    try {
      setLoading(true)
      const {data: response} = await getBedsFromBookingService({
        HuespedId: currentTabItem.idToEdit as any,
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    getBedBookings()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  useEffect(() => {
    getBedBookings() // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  const columns: Column<BedBookingModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nro. Reserva' />,
      accessor: 'CodigoReserva',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Site' />,
      accessor: 'Site',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Módulo' />,
      accessor: 'Modulo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Habitación' />,
      accessor: 'TipoHabitacion_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nomenclatura de Habitación' />,
      accessor: 'Habitacion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nomenclatura de Cama' />,
      accessor: 'CodigoCama',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Cama' />,
      accessor: 'CamaTipo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Piso' />,
      accessor: 'Nivel_descripcion',
    },

    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha Inicio' />,
      accessor: 'FechaInicio',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha Fin' />,
      accessor: 'FechaFin',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Estado de Reserva' />,
      accessor: 'Estado',
    },
  ]

  return (
    <>
      <KTCard shadow className='m-5'>
        <KTable data={data} columns={columns} />
        {loading ? <KTableLoading title='Cargando...' /> : null}
      </KTCard>
    </>
  )
}

const TableGuestBookingWrapper = () => {
  const {isAllowed} = useHoteleria()
  return (
    <KTableProvider>{isAllowed('RESERVASXHUESPED/LISTAR') && <TableGuestBooking />}</KTableProvider>
  )
}

export {TableGuestBookingWrapper}
